/* src/app/main/performance/wizard/steps/import-data/performance-import-data.component.scss */
.chart-container {
  width: 200px;
  height: 200px;
}
canvas {
  width: 100%;
  height: 100%;
}
.progress-section {
  text-align: center;
  margin: 20px 0;
}
.progress-bar {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  height: 20px;
  margin: 10px 0;
}
.progress {
  height: 100%;
  background-color: #4682B4;
  border-radius: 5px;
  transition: width 1s ease;
}
.data-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 100%;
  overflow-x: auto;
}
.data-preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
  border-radius: 10px;
  overflow: hidden;
}
.data-preview-table th,
.data-preview-table td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: center;
}
.data-preview-table thead tr {
  background-color: #006f8a;
  color: white;
  font-weight: bold;
}
.data-preview-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.data-preview-table tbody tr:nth-child(odd) {
  background-color: #fff;
}
.data-preview-table tr:hover {
  background-color: #e6f7ff;
}
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
.loading-indicator {
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 10px;
  height: 30px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.loading-indicator .spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #006f8a;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.error-details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 0.95em;
}
.error-details-table th,
.error-details-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: left;
}
.error-details-table th {
  background: #f5f7fa;
  color: #006f8a;
  font-weight: bold;
}
.error-details-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}
.error-details-group h5 {
  margin-top: 16px;
  margin-bottom: 4px;
  color: #4171a8;
  font-size: 1em;
}
.summary-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 30%;
  overflow-x: auto;
}
.summary-details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  margin-bottom: 16px;
  border-radius: 10px;
  font-size: 0.95em;
}
.summary-details-table th,
.summary-details-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: left;
}
.summary-details-table th {
  background: #f5f7fa;
  color: #006f8a;
  font-weight: bold;
}
.summary-details-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}
/*# sourceMappingURL=performance-import-data.component-VHM42QXM.css.map */
